"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _constants = require("./utils/constants");

var _Argos = _interopRequireDefault(require("./Argos"));

var _CustomerExperience = _interopRequireDefault(require("./CustomerExperience"));

var _Event = _interopRequireDefault(require("./Event"));

var _Food = _interopRequireDefault(require("./Food"));

var _FoodServices = _interopRequireDefault(require("./FoodServices"));

var _GmAndClothing = _interopRequireDefault(require("./GmAndClothing"));

var _GroceriesOnline = _interopRequireDefault(require("./GroceriesOnline"));

var _Habitat = _interopRequireDefault(require("./Habitat"));

var _LineManagers = _interopRequireDefault(require("./LineManagers"));

var _NightTwilightShift = _interopRequireDefault(require("./NightTwilightShift"));

var _Risk = _interopRequireDefault(require("./Risk"));

var _RunningTheStore = _interopRequireDefault(require("./RunningTheStore"));

var _Christmas = _interopRequireDefault(require("./Christmas"));

var _Restricted = _interopRequireDefault(require("./Restricted"));

var _FoodProduction = _interopRequireDefault(require("./FoodProduction"));

var _Beauty = _interopRequireDefault(require("./Beauty"));

var _CountdownToChristmas = _interopRequireDefault(require("./CountdownToChristmas"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var keys = Object.assign({}, _constants.activityAttributes);

var IconFor = function IconFor(_ref) {
  var value = _ref.value;

  switch (value) {
    case keys.argos:
      return /*#__PURE__*/_react.default.createElement(_Argos.default, null);

    case keys.beauty:
      return /*#__PURE__*/_react.default.createElement(_Beauty.default, null);

    case keys.countdownToChristmas:
      return /*#__PURE__*/_react.default.createElement(_CountdownToChristmas.default, null);

    case keys.customerExperience:
      return /*#__PURE__*/_react.default.createElement(_CustomerExperience.default, null);

    case keys.event:
      return /*#__PURE__*/_react.default.createElement(_Event.default, null);

    case keys.food:
      return /*#__PURE__*/_react.default.createElement(_Food.default, null);

    case keys.foodProduction:
      return /*#__PURE__*/_react.default.createElement(_FoodProduction.default, null);

    case keys.foodServices:
      return /*#__PURE__*/_react.default.createElement(_FoodServices.default, null);

    case keys.gmAndClothing:
      return /*#__PURE__*/_react.default.createElement(_GmAndClothing.default, null);

    case keys.groceriesOnline:
      return /*#__PURE__*/_react.default.createElement(_GroceriesOnline.default, null);

    case keys.habitat:
      return /*#__PURE__*/_react.default.createElement(_Habitat.default, null);

    case keys.lineManagers:
      return /*#__PURE__*/_react.default.createElement(_LineManagers.default, null);

    case keys.nightTwilightShift:
      return /*#__PURE__*/_react.default.createElement(_NightTwilightShift.default, null);

    case keys.risk:
      return /*#__PURE__*/_react.default.createElement(_Risk.default, null);

    case keys.restricted:
      return /*#__PURE__*/_react.default.createElement(_Restricted.default, null);

    case keys.runningTheStore:
      return /*#__PURE__*/_react.default.createElement(_RunningTheStore.default, null);

    case keys.christmas:
      return /*#__PURE__*/_react.default.createElement(_Christmas.default, null);

    default:
      return null;
  }
};

IconFor.propTypes = {
  value: _propTypes.PropTypes.string.isRequired
};
var _default = IconFor;
exports.default = _default;